module.exports = __webpack_public_path__ + "img/icon_user.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/icon_user.png
// module id = 320
// module chunks = 0